import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        mode: '@?',     // 'add' or 'edit'
        skillId: '<?',
        uibModalInstance: '<?',
        api: '=?'
    },
    template: `
    <div class="loader02" ng-if="vm.activating">
        <p>{{ 'question.Please wait' | translate }}</p>
    </div>
    <style>
        .switch01.visible-label {
            width: fit-content !important;
        }
    </style>
    <form role="form" ng-submit="vm.save()">
         <div class="form">
            <!-- Error Summary -->
            <div class="alert alert-danger" ng-if="vm.form && vm.form.invalid && vm.hasValidationErrors()">
                <ul>
                    <li ng-repeat="error in vm.getValidationErrorSummary()">
                        {{ error }}
                    </li>
                </ul>
            </div>

            <language-selector
                languages="vm.languages"
                selected="vm.selectedLang"
                data="vm.languageData"
                on-change="vm.onLangChange(lang, data)">
            </language-selector>
            <div class="row row-wide mt2em">
                <label class="label w100p">{{ 'skill.Skill' | translate }} *</label>
                <div class="items w100p">
                    <input type="text" class="form-control wide"
                           ng-model="vm.languageData[vm.selectedLang].name"
                           placeholder="{{ 'skill.Enter skill name' | translate }}"
                           maxlength="255"
                           autofocus>
                </div>
            </div>
            <div class="row row-wide">
                <label class="label w100p">{{ 'skill.Description' | translate }}</label>
                <div class="items w100p">
                    <textarea class="form-control wide"
                              ng-attr-maxlength="{{ vm.maxDescLen }}"
                              ng-model="vm.languageData[vm.selectedLang].description"
                              placeholder="{{ 'skill.Enter description' | translate }}"></textarea>
                    <small class="desc">
                        {{ (vm.languageData[vm.selectedLang].description || '').length }}/{{ vm.maxDescLen }}
                    </small>
                </div>
            </div>
            <div class="row row-wide">
                <label class="label w100p">{{ 'skill.Associated scale' | translate }} *</label>
                <div class="items w100p">
                    <select class="form-control wide"
                            ng-model="vm.model.scale_id"
                            ng-change="vm.onScaleChanged()"
                            ng-disabled="vm.scaleChangeDisabled"
                            title="{{ vm.scaleChangeDisabled ? vm.getScaleDisabledTooltip() : '' }}"
                            ng-options="s.id as vm.getScaleName(s) for s in vm.scales">
                        <option value="">{{ 'filter.Select' | translate }}</option>
                    </select>
                    <p class="desc error"
                       ng-if="vm.form && vm.form.errors && vm.form.errors.scale_id">{{ vm.form.errors.scale_id }}</p>
                </div>
            </div>
            <div class="row row-wide">
                <label class="label w100p">{{ 'skill.Code' | translate }}</label>
                <div class="items w100p">
                    <input type="text" class="form-control wide"
                           ng-model="vm.model.code"
                           placeholder="{{ 'skill.Optional integration code' | translate }}"
                           maxlength="255">
                </div>
            </div>
            <div class="row row-wide">
                <label class="label w100p">{{ 'skill.Status' | translate }}</label>
                <div class="items w100p">
                    <label class="switch01 visible-label">
                        <input type="checkbox"
                               ng-model="vm.model.is_active"
                               ng-disabled="vm.statusToggling"
                               ng-change="vm.onStatusChange()">
                        <span>{{ vm.model.is_active ? ('skill.Active' | translate)
                                                    : ('skill.Inactive' | translate) }}</span>
                    </label>
                </div>
            </div>
            <div class="row row-wide">
                <label class="label w100p">{{ 'skill.Skill proficiency fixed' | translate }}</label>
                <div class="items w100p">
                    <label class="switch01 visible-label">
                        <input type="checkbox" ng-model="vm.fixedProficiency" ng-change="vm.onFixedChanged()">
                        <span>{{ vm.fixedProficiency ? ('general.Yes' | translate) : ('general.No' | translate) }}</span>
                    </label>
                </div>
            </div>
            <div class="row row-wide" ng-class="{ disabled: !vm.fixedProficiency }">
                <label class="label w100p">{{ 'skill.Required proficiency' | translate }}</label>
                <div class="items w100p">
                    <select class="form-control wide"
                            ng-disabled="!vm.fixedProficiency"
                            ng-model="vm.model.required_proficiency_id"
                            ng-options="p.id as vm.proficiencyLabel(p) for p in vm.proficiencies">
                        <option value="">{{ 'filter.Select' | translate }}</option>
                    </select>
                    <p class="desc error"
                       ng-if="vm.form && vm.form.errors && vm.form.errors.required_proficiency_id">
                        {{ vm.form.errors.required_proficiency_id }}
                    </p>
                </div>
            </div>
            <div class="well color03 mt1em"
                 ng-if="vm.mode === 'add'">
                {{ 'skill.You can add descriptions to skill levels in Edit menu after adding the skill' | translate }}
            </div>
            <div class="well color03" ng-show="vm.mode==='edit' && vm.scaleLevels.length">
                <h2>{{ 'skill.Explain what the skill levels mean' | translate }}</h2>
                <div class="form">
                    <div class="row row-wide" ng-repeat="lvl in vm.scaleLevels track by lvl.id">
                        <label class="label w100p">{{ vm.levelLabel(lvl) }}</label>
                        <div class="items w100p">
                            <textarea class="form-control wide"
                                      ng-attr-maxlength="{{ vm.maxDescLen }}"
                                      ng-model="vm.levelDescriptions[lvl.id][vm.selectedLang]"
                                      placeholder="{{ 'skill.Enter level description' | translate }}"></textarea>
                            <small class="desc">
                                {{ (vm.levelDescriptions[lvl.id][vm.selectedLang] || '').length }}/{{ vm.maxDescLen }}
                            </small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
    `
})
export default class {
    constructor ($q, $state, $stateParams, $translate, lodash, toastr, SkillResource, SkillScaleResource, ProficiencyResource,
                 TokenService, ModalService, COMPANY_LANGUAGE_ENUM, $timeout, ResponseService, UserSkillResource, I18nService, UserSkillService, SkillActivationService) {
        this._paramId = $stateParams && $stateParams.id;
        this.isNew = !((this.skillId || this._paramId));
        this.$q = $q;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$translate = $translate;
        this.lodash = lodash;
        this.toastr = toastr;
        this.SkillResource = SkillResource;
        this.SkillScaleResource = SkillScaleResource;
        this.ProficiencyResource = ProficiencyResource;
        this.TokenService = TokenService;
        this.ModalService = ModalService;
        this.COMPANY_LANGUAGE_ENUM = COMPANY_LANGUAGE_ENUM;
        this.$timeout = $timeout;
        this.ResponseService = ResponseService;
        this.I18nService = I18nService;
        this.UserSkillService = UserSkillService;
        this.SkillActivationService = SkillActivationService;

        this.isNew = !($stateParams && $stateParams.id);
        this.saving = false;
        this.deleting = false;

        this.maxDescLen = 2000;
        this.fixedProficiency = false;

        this.langModel = {};
        this.languageData = this.langModel;
        this.activelang = (this.TokenService.getCompanyLanguage && this.TokenService.getCompanyLanguage()) || null;
        this.languages = []; // Will be populated in $onInit after langModel is ready
        this.selectedLang = ((this.TokenService.getCompanyLanguage && this.TokenService.getCompanyLanguage()) || 'en').toUpperCase();
        this.levelDescriptions = {};

        this.model = {
            id: null,
            scale_id: null,
            required_proficiency_id: null,
            is_active: true,
            code: null
        };

        this.scales = [];
        this.scaleLevels = [];
        this.proficiencies = [];
        this.proficiencyNames = {};
        this.connectedUsersCount = 0;
        this.scaleChangeDisabled = false;
        this.associatedPlanningGroups = [];
        this.associatedCourses = [];
    }

    $onInit () {
        if (!this.mode) this.mode = this.isNew ? 'add' : 'edit';
        this.initLangModel();
        // Build language list after langModel is initialized (for add mode)
        // For edit mode, it will be rebuilt in loadSkill after API data is loaded
        if (this.isNew) {
            this.languages = this.buildLanguageList();
        }
        const p1 = this.loadScales();
        const editId = this.skillId || this._paramId;
        const p2 = this.isNew ? this.$q.when() : this.loadSkill(editId);
        this.$q.all([p1, p2]).then(() => {
            if (this.model.scale_id) {
                return this.loadScaleAndProficiencies(this.model.scale_id);
            }
            return null;
        });
        this.api = this.api || {};
        this.api.save = this.save.bind(this);
        this.api.delete = this.delete.bind(this);
        this.api.cancel = this.uibModalInstance
            ? this.cancelModal.bind(this)
            : () => this.$state.go('authorized.user.skill.list.skill');
    }

    buildLanguageList () {
        const supported = this.getSupportedLanguages();
        const defaultLang = ((this.TokenService.getCompanyLanguage && this.TokenService.getCompanyLanguage()) || '').toUpperCase();

        // Always return all supported languages, but with correct enabled state
        const list = supported.map(label => {
            const row = this.langModel[label];
            // In edit mode, only mark as enabled if explicitly in langModel with enabled=true
            // In add mode or if row exists, use the enabled flag or check for content
            let enabled = false;
            if (row) {
                if (typeof row.enabled === 'boolean') {
                    enabled = row.enabled;
                }
                else {
                    enabled = !!(row.name || row.description);
                }
            }
            return { code: label, label, enabled };
        });

        // Sort: default language first, then others
        return list.sort((a, b) => {
            if (a.label === defaultLang) return -1;
            if (b.label === defaultLang) return 1;
            return 0;
        });
    }

    initLangModel () {
        // In 'add' mode, pre-populate langModel with the default language enabled
        if (this.mode === 'add') {
            const defaultLang = ((this.TokenService.getCompanyLanguage && this.TokenService.getCompanyLanguage()) || 'en').toUpperCase();
            if (!this.langModel[defaultLang]) {
                this.langModel[defaultLang] = { enabled: true, name: '', description: '' };
            }
        }
        // Note: In 'edit' mode, langModel is populated from API data in loadSkill, so we don't pre-populate here
    }

    getProficiencyName (proficiencyId) {
        const i18ns = this.proficiencyNames[proficiencyId] || {};

        const i18n = this.I18nService.getPreferredI18n(i18ns);
        if (i18n && i18n.value) {
            return i18n.value;
        }

        // Fallback to empty string if no name found
        return '';
    }

    levelLabel (lvl) {
        const no = lvl.order_no || lvl.id;
        const nm = this.getProficiencyName(lvl.id);
        return nm ? `${no} - ${nm}` : `${no}`;
    }

    loadScales () {
        return this.SkillScaleResource.query({ expand: 'activeI18n,scaleI18ns' }).$promise.then(res => {
            this.scales = res.items || res;
            return this.scales;
        });
    }

    getScaleName (scale) {
        if (!scale) {
            return '';
        }

        // If scale has scaleI18ns, use I18nService
        if (scale.scaleI18ns) {
            const i18n = this.I18nService.getPreferredI18n(scale.scaleI18ns);
            if (i18n && i18n.name) {
                return i18n.name;
            }
        }

        // Fallback to ID if no name found
        return `#${scale.id}`;
    }

    loadSkill (id) {
        const expand = 'i18ns,scale.activeI18n,explanations.i18ns,planningGroups,courseSkills';
        return this.SkillResource.get({ id, expand }).$promise.then(s => {
            // Store associated planning groups
            this.associatedPlanningGroups = s.planningGroups || [];
            this.associatedCourses = s.courseSkills || [];
            const norm = this.normalizeSkill(s);
            this.model.id = norm.id;
            this.model.scale_id = norm.scale_id || (norm.scale && norm.scale.id);
            this.model.required_proficiency_id = norm.required_proficiency_id || null;
            this.model.is_active = !!norm.is_active;
            this.model.code = norm.code || null;
            this.originalIsActive = !!norm.is_active;

            this.fixedProficiency = !!this.model.required_proficiency_id;

            // In edit mode, initialize langModel with all supported languages first
            this.langModel = {};
            const supported = this.getSupportedLanguages();
            supported.forEach(lang => {
                this.langModel[lang] = { enabled: false, name: '', description: '' };
            });

            // Then populate from API response
            const i18n = norm.i18n || {};
            Object.keys(i18n).forEach(lang => {
                const row = i18n[lang] || {};
                const L = lang.toUpperCase();
                if (!this.langModel[L]) {
                    this.langModel[L] = { enabled: false, name: '', description: '' };
                }
                this.langModel[L].enabled = !!row.enabled;
                this.langModel[L].name = row.name || '';
                this.langModel[L].description = row.description || '';
            });

            // Force a new array reference to trigger $onChanges in language-selector
            this.languages = this.buildLanguageList().slice();

            // In edit mode, prefer the default UI language if enabled; otherwise select the first enabled language
            const defaultLang = this.defaultLanguage || this.selectedLang;
            const defaultLangEnabled = this.languages.find(l => l.label === defaultLang && l.enabled);
            const firstEnabledLang = this.languages.find(l => l.enabled);

            // Use $timeout to ensure digest cycle runs and language-selector's $doCheck detects the change
            this.$timeout(() => {
                if (defaultLangEnabled) {
                    this.selectedLang = defaultLangEnabled.label;
                }
                else if (firstEnabledLang) {
                    this.selectedLang = firstEnabledLang.label;
                }
                else {
                    this.selectedLang = this.languages[0] && this.languages[0].label;
                }
            }, 0);

            this.languageData = this.langModel;

            const exps = (norm.explanations || []);

            exps.forEach(ex => {
                const pid = ex.proficiency_id || ex.proficiencyId;
                if (!pid) return;
                if (!this.levelDescriptions[pid]) this.levelDescriptions[pid] = {};

                const map = ex.explanationI18ns || ex.i18ns || {};
                Object.keys(map).forEach(langKey => {
                    const row = map[langKey] || {};
                    const L = (row.language || langKey || '').toUpperCase();
                    this.levelDescriptions[pid][L] = row.value || '';
                });
            });

            return norm;
        }).then(() => {
            // Check connected users count in edit mode
            if (this.mode === 'edit' && this.model.id) {
                return this.checkConnectedUsers(this.model.id);
            }
            return null;
        });
    }

    checkConnectedUsers (skillId) {
        return this.UserSkillService.countUsers(skillId)
            .then((count) => {
                this.connectedUsersCount = count;
                this.updateScaleChangeDisabled();
            })
            .catch(() => {
                this.connectedUsersCount = 0;
                this.updateScaleChangeDisabled();
            });
    }

    updateScaleChangeDisabled () {
        const hasUsers = this.connectedUsersCount > 0;
        const hasPlanningGroups = this.associatedPlanningGroups && this.associatedPlanningGroups.length > 0;
        const hasCoursesAssociated = this.associatedCourses && this.associatedCourses.length > 0;
        this.scaleChangeDisabled = hasUsers || hasPlanningGroups || hasCoursesAssociated;
    }

    getScaleDisabledTooltip () {
        const reasons = [];
        if (this.connectedUsersCount > 0) {
            reasons.push(this.$translate.instant('skill.Cannot change scale when users are connected to this skill'));
        }
        if (this.associatedPlanningGroups && this.associatedPlanningGroups.length > 0) {
            reasons.push(this.$translate.instant('skill.Cannot change scale when skill is used in automated planning groups'));
        }
        return reasons.join('. ');
    }

    pickScaleLevels (scaleId) {
        const scale = this.lodash.find(this.scales, s => (s.id || s._id) === scaleId);
        const levels = (scale && (scale.levels || [])) || [];
        this.scaleLevels = this.lodash.sortBy(levels, l => l.order_no || l.id);

        this.scaleLevels.forEach(l => {
            if (!this.levelDescriptions[l.id]) this.levelDescriptions[l.id] = {};
            this.languages.forEach(lang => {
                const k = lang.label;
                if (typeof this.levelDescriptions[l.id][k] !== 'string') {
                    this.levelDescriptions[l.id][k] = '';
                }
            });
        });

        Object.keys(this.levelDescriptions).forEach(k => {
            const keep = this.scaleLevels.some(l => `${l.id}` === `${k}`);
            if (!keep) delete this.levelDescriptions[k];
        });

        if (this.model.required_proficiency_id) {
            const ok = this.scaleLevels.some(l => `${l.id}` === `${this.model.required_proficiency_id}`);
            if (!ok) this.model.required_proficiency_id = null;
        }
    }

    onScaleChanged () {
        if (!this.model.scale_id) {
            this.scaleLevels = [];
            this.levelDescriptions = {};
            this.model.required_proficiency_id = null;
            this.proficiencies = [];
            return;
        }
        const msg = this.$translate.instant('skill.SkillSkillScaleChangeWarningMessage');
        const doPick = () => this.loadScaleAndProficiencies(this.model.scale_id);
        // Only show confirmation in edit mode when there's existing data
        if (this.mode === 'edit' && (this.scaleLevels.length || Object.keys(this.levelDescriptions).length)) {
            this.ModalService.confirm(msg, 'medium').then(doPick).catch(() => {});
        }
        else {
            doPick();
        }
    }

    onFixedChanged () {
        if (!this.fixedProficiency) this.model.required_proficiency_id = null;
    }

    onStatusChange () {
        // Only check for APG confirmation in edit mode when status actually changed
        if (this.isNew || this.statusToggling) return;

        const newValue = !!this.model.is_active;
        if (newValue === this.originalIsActive) return;

        this.statusToggling = true;
        const skillId = this.$stateParams.id || this.model.id;

        this.SkillActivationService.checkAndConfirm(skillId)
            .then((result) => {
                if (result.proceed) {
                    // User confirmed (or no APGs), call activation API immediately
                    const showLoader = result.affectedApgs && result.affectedApgs.length > 0;
                    return this.performActivation(skillId, newValue, showLoader);
                }
                // User cancelled, revert the toggle
                this.model.is_active = this.originalIsActive;
                return null;
            })
            .catch(() => {
                // Error checking APGs, revert the toggle
                this.model.is_active = this.originalIsActive;
                this.toastr.error(this.$translate.instant('skill.Failed to check APG connections'));
            })
            .finally(() => {
                this.statusToggling = false;
            });
    }

    performActivation (skillId, newValue, showLoader) {
        if (showLoader) this.activating = true;
        return this.SkillResource.activation({ id: skillId }, { is_active: newValue }).$promise
            .then(() => {
                this.model.is_active = newValue;
                this.originalIsActive = newValue;
                const msg = newValue
                    ? this.$translate.instant('skill.Skill enabled')
                    : this.$translate.instant('skill.Skill disabled');
                this.toastr.success(msg);
            })
            .catch((err) => {
                this.model.is_active = this.originalIsActive;
                const msg = newValue
                    ? this.$translate.instant('skill.Enable failed')
                    : this.$translate.instant('skill.Disable failed');
                this.toastr.error(err && err.data && err.data.message ? err.data.message : msg);
            })
            .finally(() => {
                this.activating = false;
            });
    }

    buildPayload () {
        const i18nArray = [];
        this.languages.forEach(l => {
            const row = this.langModel[l.label];
            if (!row) return;

            // Skip disabled languages with no name - they should not be sent to backend
            const hasName = (row.name || '').trim() !== '';
            const isEnabled = !!row.enabled;
            if (!isEnabled && !hasName) {
                return;
            }

            i18nArray.push({
                language: l.label,
                name: row.name || '',
                description: (row.description === '' ? null : row.description),
                is_enabled: isEnabled ? 1 : 0
            });
        });

        const explanations = [];
        Object.keys(this.levelDescriptions).forEach(pid => {
            const map = this.levelDescriptions[pid] || {};
            // Send explanations for ALL languages (enabled and disabled) with non-empty values
            const explanationI18ns = {};
            this.languages.forEach(LANG => {
                const code = LANG.label.toUpperCase();
                if (!this.langModel[code]) return;
                const val = (map[code] || '').trim();
                // Only send if value is not empty (preserve disabled language explanations)
                if (val !== '') {
                    explanationI18ns[code] = { language: code, value: val };
                }
            });
            // Always send the proficiency, even if all values are empty
            // This allows backend to delete explanations when all values are cleared
            explanations.push({
                skill_id: this.model.id || null, // backend uses current model id anyway
                proficiency_id: parseInt(pid, 10),
                explanationI18ns
            });
        });

        return {
            scale_id: this.model.scale_id,
            required_proficiency_id: this.fixedProficiency ? (this.model.required_proficiency_id || null) : null,
            is_active: !!this.model.is_active,
            code: this.model.code || null,
            i18n: i18nArray,
            explanations
        };
    }

    save () {
        // Clear previous errors at the start of save
        this.form = { errors: {}, invalid: false };

        // Frontend validation: if fixedProficiency is checked, required_proficiency_id must be selected
        if (this.fixedProficiency && !this.model.required_proficiency_id) {
            this.form.errors.required_proficiency_id = this.$translate.instant('skill.Required proficiency must be selected when skill proficiency is fixed');
            this.form.invalid = true;
            return;
        }

        // APG confirmation is now handled in onStatusChange() when toggle changes
        this.saving = true;
        const payload = this.buildPayload();

        const req = this.isNew
            ? this.SkillResource.save(payload).$promise
            : this.SkillResource.update({ id: this.$stateParams.id }, payload).$promise;

        req.then((result) => {
            this.toastr.success(this.$translate.instant('skill.Saved'));
            // Update original value after successful save
            this.originalIsActive = !!this.model.is_active;
            if (this.isNew && result && result.id) {
                // For new skills, navigate to the edit page
                // Close modal first if in modal context (dismiss to prevent list reload)
                if (this.uibModalInstance) {
                    this.uibModalInstance.dismiss('navigating');
                }
                this.$state.go('authorized.user.skill.edit.skill', { id: result.id });
            }
            else if (this.uibModalInstance) {
                this.uibModalInstance.close(result || true);
            }
        }).catch((response) => {
            this.form = this.form || { errors: {}, invalid: false };
            this.form.errors = this.ResponseService.parseErrors(response);
            this.form.invalid = true;
        }).finally(() => {
            this.saving = false;
        });
    }

    cancelModal () {
        if (this.uibModalInstance) this.uibModalInstance.dismiss('cancel');
    }

    delete () {
        if (this.isNew) {
            this.$state.go('authorized.user.skill.list.skill');
            return;
        }

        const loadUserCount = () => {
            return this.UserSkillService.countUsers(this.$stateParams.id);
        };

        this.deleting = true;
        loadUserCount().then((usersCount) => {
            const warn = `${this.$translate.instant('skill.DeleteWarningMessage')} ${usersCount}`;
            return this.ModalService.confirm(warn, 'large').then(() => {
                return this.SkillResource.delete({ id: this.$stateParams.id }).$promise.then(() => {
                    this.toastr.success(this.$translate.instant('skill.Skill deleted'));
                    this.$state.go('authorized.user.skill.list.skill');
                });
            });
        }).catch(() => {}).finally(() => {
            this.deleting = false;
        });
    }

    normalizeSkill (s) {
        const scale = s.scale || {};
        const raw = s.i18n || s.i18ns || {};
        const i18nObj = {};

        Object.keys(raw).forEach(k0 => {
            const k = (k0 || '').toUpperCase();
            const row = raw[k0] || {};
            i18nObj[k] = {
                name: row.name || '',
                description: row.description || null,
                enabled: !!row.isEnabled
            };
        });

        const explanations = (s.explanations || []).map(e => {
            const pid = e.proficiency_id || e.proficiencyId;
            const langMap = e.i18ns || e.explanationI18ns || e.i18n || {};

            const normalized = {};
            Object.keys(langMap).forEach(k => {
                const row = langMap[k] || {};
                const L = (row.language || k || '').toUpperCase();
                normalized[L] = { language: L, value: row.value || '' };
            });

            return {
                proficiency_id: pid,
                explanationI18ns: normalized
            };
        });

        return {
            id: s.id,
            scale_id: s.scale_id || s.scaleId || scale.id || null,
            required_proficiency_id: s.required_proficiency_id || s.requiredProficiencyId || null,
            is_active: (s.is_active !== undefined) ? s.is_active : !!s.isActive,
            code: s.code || null,
            scale: { id: scale.id || null, activeI18n: scale.activeI18n || null },
            i18n: i18nObj,
            explanations
        };
    }

    onLangChange (lang, data) {
        const k = (lang || '').toUpperCase();
        if (!k) return;
        this.selectedLang = k;

        if (!this.languageData[k]) {
            this.languageData[k] = { enabled: false, name: '', description: '' };
        }
        if (data && typeof data.enabled !== 'undefined') {
            this.languageData[k].enabled = !!data.enabled;
        }

        // ensure explanation fields exist for this language
        (this.scaleLevels || []).forEach(l => {
            if (!this.levelDescriptions[l.id]) {
                this.levelDescriptions[l.id] = {};
            }
            if (typeof this.levelDescriptions[l.id][k] !== 'string') {
                this.levelDescriptions[l.id][k] = '';
            }
        });

        this.proficiencies = (this.proficiencies || []).map(p => {
            const nm = this.getProficiencyName(p.id);
            return Object.assign({}, p, { activeI18n: { value: nm } });
        });
    }

    getSupportedLanguages () {
        const arr = (this.TokenService.getCompanySupportedLanguages &&
            this.TokenService.getCompanySupportedLanguages()) || [];
        return arr.map(x => (x || '').toUpperCase()).filter(Boolean);
    }

    proficiencyLabel (p) {
        const no = (typeof p.points === 'number') ? p.points : (p.order_no || p.id);
        const nm = this.getProficiencyName(p.id);
        return (no && nm) ? `${no} - ${nm}` : (nm || `#${p.id || no}`);
    }

    loadProficiencies (scaleId) {
        if (!scaleId) {
            this.proficiencies = [];
            return this.$q.when([]);
        }
        return this.ProficiencyResource.query({ scale_id: scaleId, expand: 'activeI18n' }).$promise
            .then(res => {
                const arr = res.items || res || [];
                this.proficiencies = this.lodash.sortBy(arr, x => x.points || x.order_no || x.id);
                // keep selection only if it still exists for this scale
                const ok = this.proficiencies.some(
                    p => `${p.id}` === `${this.model.required_proficiency_id}`
                );
                if (!ok) this.model.required_proficiency_id = null;
                return this.proficiencies;
            })
            .catch(() => {
                // Placeholder fallback while API isn’t ready: map from current scaleLevels
                this.proficiencies = (this.scaleLevels || []).map(l => ({
                    id: l.id, points: l.order_no || l.id,
                    activeI18n: l.activeI18n ? { value: l.activeI18n.name } : null
                }));
                const ok = this.proficiencies.some(
                    p => `${p.id}` === `${this.model.required_proficiency_id}`
                );
                if (!ok) this.model.required_proficiency_id = null;
                return this.proficiencies;
            });
    }

    loadScaleAndProficiencies (scaleId) {
        if (!scaleId) {
            this.proficiencies = [];
            this.scaleLevels = [];
            this.model.required_proficiency_id = null;
            return this.$q.when(null);
        }

        const params = { id: scaleId, expand: 'activeI18n,scaleI18ns,proficiencies.skillProficiencyI18n' };
        const digest = (fn) => (this.$timeout ? this.$timeout(fn, 0) : fn());

        return this.SkillScaleResource.get(params).$promise.then((scale) => {
            const profs = Array.isArray(scale && scale.proficiencies) ? scale.proficiencies : [];

            // Get enabled languages from the scale
            const enabledLanguages = {};
            if (scale.scaleI18ns) {
                Object.keys(scale.scaleI18ns).forEach(lang => {
                    const i18n = scale.scaleI18ns[lang];
                    if (i18n && i18n.isEnabled) {
                        enabledLanguages[lang] = true;
                    }
                });
            }

            this.proficiencyNames = {};
            (profs || []).forEach(p => {
                // Filter proficiency translations to only include enabled languages
                const filteredI18ns = {};
                const allI18ns = p.skillProficiencyI18n || {};
                Object.keys(allI18ns).forEach(lang => {
                    if (enabledLanguages[lang]) {
                        filteredI18ns[lang] = allI18ns[lang];
                    }
                });
                this.proficiencyNames[p.id] = filteredI18ns;
            });

            const levels = profs.map(p => ({
                id: p.id,
                order_no: (typeof p.points === 'number') ? p.points : (p.order_no || p.id)
            })).sort((a, b) => (a.order_no === b.order_no ? a.id - b.id : a.order_no - b.order_no));

            const options = profs.map(p => ({
                id: p.id,
                points: (typeof p.points === 'number') ? p.points : (p.order_no || p.id),
                activeI18n: { value: this.getProficiencyName(p.id) }
            })).sort((a, b) => (a.points === b.points ? a.id - b.id : a.points - b.points));

            digest(() => {
                this.scaleLevels = levels;
                this.proficiencies = options;

                const ok = this.proficiencies.some(x => `${x.id}` === `${this.model.required_proficiency_id}`);
                if (!ok) this.model.required_proficiency_id = null;

                this.ensureLevelDescriptionsSkeleton();
            });

            return scale;
        });
    }

    ensureLevelDescriptionsSkeleton () {
        (this.scaleLevels || []).forEach(l => {
            if (!this.levelDescriptions[l.id]) this.levelDescriptions[l.id] = {};
            this.languages.forEach(lang => {
                const k = lang.label.toUpperCase();
                if (typeof this.levelDescriptions[l.id][k] !== 'string') {
                    this.levelDescriptions[l.id][k] = '';
                }
            });
        });
        Object.keys(this.levelDescriptions).forEach(k => {
            const keep = this.scaleLevels.some(l => `${l.id}` === `${k}`);
            if (!keep) delete this.levelDescriptions[k];
        });
    }

    hasValidationErrors () {
        return this.form && this.form.errors && Object.keys(this.form.errors).length > 0;
    }

    getValidationErrorSummary () {
        if (!this.form || !this.form.errors) return [];
        const errors = [];

        // Recursive function to extract error messages from nested structures
        const extractErrors = (obj) => {
            if (!obj) return;

            if (Array.isArray(obj)) {
                // Array of error messages
                obj.forEach(item => extractErrors(item));
            }
            else if (typeof obj === 'string') {
                // Single error message
                errors.push(obj);
            }
            else if (typeof obj === 'object') {
                // Nested object - recursively process all values
                Object.values(obj).forEach(value => extractErrors(value));
            }
        };

        extractErrors(this.form.errors);
        return errors;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/user/skill/form/skill/index.js